import { render } from "./ClientRequest.vue?vue&type=template&id=1bff96d0&ts=true"
import script from "./ClientRequest.vue?vue&type=script&lang=ts"
export * from "./ClientRequest.vue?vue&type=script&lang=ts"

import "./ClientRequest.vue?vue&type=style&index=0&id=1bff96d0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__